import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import classNames from 'classnames';

import { Scrollbars } from 'react-custom-scrollbars';

import { withStyles } from '@material-ui/core/styles';
import Popover from '@material-ui/core/Popover';
import MuiMenuList from '@material-ui/core/MenuList';
import Drawer from '@material-ui/core/Drawer';
import withWidth from '@material-ui/core/withWidth';

import Link from 'components/common/Link';
import IconPlus from 'components/icons/IconPlus';

const arrowRootWidth = 30;

const styles = theme => ({
  paper: {
    borderRadius: 5,
    overflow: 'visible',
  },
  paperBottomLeft: {
    transform: 'translateX(0)!important',
  },
  paperBottomRight: {
    transform: 'translateX(-100%)!important',
  },
  paperBottomMiddle: {
    transform: 'translateX(-50%)!important',
    '& $arrowRoot': {
      left: '50%',
      right: 'auto',
      transform: 'translateX(-50%)',
    },
  },
  paperTopLeft: {
    transform: 'translateY(-100%)!important',
    '& $arrowRoot': {
      top: '100%',
      transform: 'rotate(180deg)',
    },
  },
  paperTopRight: {
    transform: 'translateX(-100%) translateY(-100%)!important',
    '& $arrowRoot': {
      top: '100%',
      transform: 'rotate(180deg)',
    },
  },
  paperTopMiddle: {
    transform: 'translateX(-50%) translateY(-100%)!important',
    '& $arrowRoot': {
      top: '100%',
      left: '50%',
      right: 'auto!important',
      transform: 'translateX(-50%) rotate(180deg)',
    },
  },
  paperMiddleLeft: {
    transform: 'translateY(-50%)!important',
    '& $arrowRoot': {
      display: 'none',
    },
  },
  paperMiddleRight: {
    transform: 'translateX(-100%) translateY(-50%)!important',
    '& $arrowRoot': {
      display: 'none',
    },
  },
  paperMiddleMiddle: {
    transform: 'translateX(-50%) translateY(-50%)!important',
    '& $arrowRoot': {
      display: 'none',
    },
  },
  content: {
    padding: '24px 16px',
  },
  contentPaddingNone: {
    padding: 0,
  },
  arrowRoot: {
    position: 'absolute',
    top: -20,
    right: 0,
    width: arrowRootWidth,
    height: 20,
    overflow: 'hidden',
    pointerEvents: 'none',
  },
  arrowArrow: {
    position: 'relative',
    top: 12,
    left: '50%',
    marginLeft: -8,
    width: 16,
    height: 16,
    background: theme.palette.common.white,
    transform: 'rotate(45deg)',
    borderRadius: '4px 0 0 0',
    boxShadow: theme.shadows[2],
  },
  listHeader: {
    zIndex: 100,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    padding: '0 16px',
  },
  listAdornment: {
    zIndex: 100,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    padding: '0 16px',
    borderTop: `1px solid ${theme.palette.primary.A100}`,
  },
  iconPlus: {
    width: 14,
    height: 14,
    marginRight: 13,
  },
});

class Menu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      arrowOffset: 0,
      placement: props.placement,
      popoverTop: 0,
      popoverLeft: 0,
      listAdornmentClicked: false,
    };

    this.onEnter = this.onEnter.bind(this);
    this.focus = this.focus.bind(this);
    this.handleListKeyDown = this.handleListKeyDown.bind(this);
    this.onListAdornmentClick = this.onListAdornmentClick.bind(this);
    this.onListAdornmentKeyDown = this.onListAdornmentKeyDown.bind(this);
    this.onPopoverExited = this.onPopoverExited.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { anchorEl, maxHeight, onListAdornmentClick } = nextProps;
    if (anchorEl) {
      let { placement } = nextProps;
      let popoverTop = 0;
      let popoverLeft = 0;
      const domRect = anchorEl.getBoundingClientRect();
      const listAdornmentHeight = onListAdornmentClick ? 40 : 0;
      if ((window.innerHeight - domRect.top - domRect.height) < (maxHeight + listAdornmentHeight)
       && domRect.top < (maxHeight + listAdornmentHeight)) {
        placement = placement.replace('bottom', 'middle');
      } else if ((window.innerHeight - domRect.top - domRect.height)
       < (maxHeight + listAdornmentHeight)) {
        placement = placement.replace('bottom', 'top');
      }
      switch (placement) {
        case 'bottom-right':
          popoverTop = domRect.top + domRect.height;
          popoverLeft = domRect.left + domRect.width;
          break;
        case 'bottom-middle':
          popoverTop = domRect.top + domRect.height;
          popoverLeft = domRect.left + (domRect.width / 2);
          break;
        case 'bottom-left':
          popoverTop = domRect.top + domRect.height;
          popoverLeft = domRect.left;
          break;
        case 'top-left':
          popoverTop = domRect.top;
          popoverLeft = domRect.left;
          break;
        case 'top-right':
          popoverTop = domRect.top;
          popoverLeft = domRect.left + domRect.width;
          break;
        case 'top-middle':
          popoverTop = domRect.top;
          popoverLeft = domRect.left + (domRect.width / 2);
          break;
        case 'middle-left':
          popoverTop = window.innerHeight / 2;
          popoverLeft = domRect.left;
          break;
        case 'middle-right':
          popoverTop = window.innerHeight / 2;
          popoverLeft = domRect.left + domRect.width;
          break;
        case 'middle-middle':
          popoverTop = window.innerHeight / 2;
          popoverLeft = domRect.left + (domRect.width / 2);
          break;
        default:
          popoverTop = 0;
          popoverLeft = 0;
      }
      this.setState({
        placement,
        popoverTop,
        popoverLeft,
      });
    }
  }

  onEnter(element) {
    this.setState({ listAdornmentClicked: false });
    if (this.props.list) {
      this.focus();
    }
    const arrowOffset = (this.props.anchorEl.getBoundingClientRect().width / 2)
     - (arrowRootWidth / 2);

    this.setState({ arrowOffset });

    if (this.props.onEnter) {
      this.props.onEnter(element);
    }
  }

  onListAdornmentClick() {
    const { onClose } = this.props;
    onClose();
    this.setState({ listAdornmentClicked: true });
  }

  onListAdornmentKeyDown(event) {
    const { onClose } = this.props;
    if (event.key === 'Tab') {
      event.preventDefault();

      if (onClose) {
        onClose(event);
      }
    }
  }

  onPopoverExited() {
    const { onListAdornmentClick } = this.props;
    const { listAdornmentClicked } = this.state;
    if (listAdornmentClicked) {
      onListAdornmentClick();
    }
  }

  focus() {
    if (this.menuList && this.menuList.selectedItem) {
      // eslint-disable-next-line react/no-find-dom-node
      findDOMNode(this.menuList.selectedItem).focus();
      return;
    }

    // eslint-disable-next-line react/no-find-dom-node
    const menuList = findDOMNode(this.menuList);
    if (menuList && menuList.firstChild) {
      setTimeout(() => { menuList.firstChild.focus(); }, 0);
    }
  }

  handleListKeyDown(event) {
    const { onClose, onListAdornmentClick } = this.props;
    if (event.key === 'Tab' && !onListAdornmentClick) {
      event.preventDefault();

      if (onClose) {
        onClose(event);
      }
    }
  }

  render() {
    const {
      children,
      classes,
      id,
      open,
      onClose,
      onExited,
      list,
      listHeader,
      onListAdornmentClick,
      listAdornmentText,
      arrow,
      padding,
      maxHeight,
      onScrollFrame,
      className,
      width,
    } = this.props;
    const { placement, popoverTop, popoverLeft, arrowOffset } = this.state;
    const arrowRootStyle = {
      ...(placement === 'bottom-right' || placement === 'top-right')
        ? { right: arrowOffset } : {},
      ...(placement === 'bottom-left' || placement === 'top-left')
        ? { left: arrowOffset } : {},
    };
    if (['xs', 'sm'].indexOf(width) !== -1) {
      return (
        <Drawer
          classes={{
            paper: classes.drawerPaper,
          }}
          anchor="bottom"
          open={open}
          onClose={(event) => {
            event.stopPropagation();
            onClose();
          }}
        >
          {list ? (
            <Fragment>
              {listHeader !== null && children &&
                <div className={classes.listHeader}>
                  {this.props.listHeader}
                </div>
              }
              <MuiMenuList
                data-mui-test="Menu"
                role="menu"
                onKeyDown={this.handleListKeyDown}
                disablePadding
                ref={(node) => {
                  this.menuList = node;
                }}
              >
                {children}
              </MuiMenuList>
              {onListAdornmentClick !== null && children &&
                <div
                  className={classes.listAdornment}
                  ref={(listAdornmentRef) => {
                    this.listAdornmentRef = listAdornmentRef;
                  }}
                >
                  <Link
                    color="primary"
                    bold
                    onClick={this.onListAdornmentClick}
                    onKeyDown={this.onListAdornmentKeyDown}
                  >
                    <IconPlus className={classes.iconPlus} />
                    {listAdornmentText}
                  </Link>
                </div>
              }
            </Fragment>
          ) : (
            <div
              className={classNames(classes.content, {
                [classes.contentPaddingNone]: padding === 'none',
              })}
            >
              {children}
            </div>
          )}
        </Drawer>
      );
    }
    return (
      <Popover
        id={id}
        classes={{
          paper: classNames(classes.paper, {
            [classes.paperBottomLeft]: placement === 'bottom-left',
            [classes.paperBottomRight]: placement === 'bottom-right',
            [classes.paperBottomMiddle]: placement === 'bottom-middle',
            [classes.paperTopRight]: placement === 'top-right',
            [classes.paperTopLeft]: placement === 'top-left',
            [classes.paperTopMiddle]: placement === 'top-middle',
            [classes.paperMiddleRight]: placement === 'middle-right',
            [classes.paperMiddleLeft]: placement === 'middle-left',
            [classes.paperMiddleMiddle]: placement === 'middle-middle',
          }),
        }}
        className={className}
        open={open}
        onClose={onClose}
        onExited={this.onPopoverExited}
        anchorReference="anchorPosition"
        anchorPosition={{
          top: popoverTop,
          left: popoverLeft,
        }}
        getContentAnchorEl={null}
        marginThreshold={-300}
        onEnter={this.onEnter}
        {...onExited ? { onExited } : {}}
        elevation={2}
      >
        {list ? (
          <Fragment>
            {listHeader !== null && children &&
              <div className={classes.listHeader}>
                {this.props.listHeader}
              </div>
            }
            <Scrollbars
              autoHeight
              autoHeightMin={0}
              autoHeightMax={maxHeight}
              thumbMinSize={30}
              universal
              {...onScrollFrame ? { onScrollFrame } : {}}
            >
              <MuiMenuList
                data-mui-test="Menu"
                role="menu"
                onKeyDown={this.handleListKeyDown}
                disablePadding
                ref={(node) => {
                  this.menuList = node;
                }}
              >
                {children}
              </MuiMenuList>
            </Scrollbars>
            {onListAdornmentClick !== null && children &&
              <div
                className={classes.listAdornment}
                ref={(listAdornmentRef) => {
                  this.listAdornmentRef = listAdornmentRef;
                }}
              >
                <Link
                  color="primary"
                  bold
                  onClick={this.onListAdornmentClick}
                  onKeyDown={this.onListAdornmentKeyDown}
                >
                  <IconPlus className={classes.iconPlus} />
                  {listAdornmentText}
                </Link>
              </div>
            }
          </Fragment>
        ) : (
          <div
            className={classNames(classes.content, {
              [classes.contentPaddingNone]: padding === 'none',
            })}
          >
            {children}
          </div>
        )}
        {arrow &&
          <div className={classes.arrowRoot} style={arrowRootStyle}>
            <div className={classes.arrowArrow} />
          </div>
        }
      </Popover>
    );
  }
}

Menu.propTypes = {
  id: PropTypes.string,
  open: PropTypes.bool,
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func,
  onExited: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  anchorEl: PropTypes.object,
  onEnter: PropTypes.func,
  list: PropTypes.bool,
  listHeader: PropTypes.node,
  onListAdornmentClick: PropTypes.func,
  listAdornmentText: PropTypes.string,
  arrow: PropTypes.bool,
  placement: PropTypes.oneOf([
    'bottom-left',
    'bottom-middle',
    'bottom-right',
    'top-left',
    'top-middle',
    'top-right',
  ]),
  padding: PropTypes.oneOf(['default', 'none']),
  className: PropTypes.string,
  maxHeight: PropTypes.number,
  onScrollFrame: PropTypes.func,
  classes: PropTypes.shape({
    paper: PropTypes.string.isRequired,
    listHeader: PropTypes.string.isRequired,
    listAdornment: PropTypes.string.isRequired,
  }).isRequired,
};

Menu.defaultProps = {
  id: '',
  open: false,
  onClose: null,
  onEnter: null,
  onExited: null,
  anchorEl: {},
  list: true,
  arrow: true,
  placement: 'bottom-right',
  padding: 'default',
  maxHeight: 200,
  onScrollFrame: null,
  listHeader: null,
  onListAdornmentClick: null,
  listAdornmentText: 'Add From List',
  className: '',
};

export default withWidth()(withStyles(styles)(Menu));



// WEBPACK FOOTER //
// ./src/components/common/Menu/Menu.js